
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm5.438-23H8.39C8.13 9 8 9.104 8 9.313v8.359c0 .078.046.156.137.234.09.078.175.117.254.117h2.226V21.5l3.516-3.477h7.305c.182 0 .273-.117.273-.351v-8.36c0-.208-.091-.312-.273-.312zm2.5 2.46h-1.25v6.524c0 .677-.326 1.016-.977 1.016h-7.07l-1.524 1.523h5.078L21.711 24v-3.477h2.227c.208 0 .312-.117.312-.351v-8.36c0-.234-.104-.351-.313-.351z"}})])
          )
        }
      }
    